<template>
  <Teleport to="#modal" :disabled="!full">
    <component
      :is="full ? 'DialogModal' : 'Popover'"
      ref="view"
      v-bind="$attrs"
      v-body-scroll-lock="full"
      :role="full ? 'dialog' : undefined"
      :aria-modal="full ? 'true' : undefined"
      :aria-label="full ? $t('status.known_participants') : undefined"
      :class="{ 'participant-dialog': full }"
      :on-cancel="closeFull"
      trigger="hover"
      placement="top"
      :offset="{ y: 5 }"
      @show="loadUsers()"
      @keydown="onKeydown"
    >
      <template #trigger>
        <slot />
      </template>
      <template v-if="full" #header>
        {{ $t('status.known_participants') }}
        <slot name="categories" />
      </template>
      <template #[full?'default':'content']>
        <div ref="list" class="user-list-popover" :class="{ '-full': full }">
          <div v-if="!full && users.length > 16" class="participants-more">
            {{ $t('status.participants_more', { count: users.length - 16 }) }}
          </div>
          <div v-else-if="!full && hasMore" class="participants-more">
            {{ $t('status.participants_more_available') }}
          </div>
          <button v-if="!full" class="btn button-default participants-view-all" type="button" @click.stop="openFull">
            {{ $t('status.view_all_participants') }}
          </button>
          <template v-if="loading">
            <FAIcon icon="circle-notch" spin size="2x" :title="$t('general.loading')" />
          </template>
          <template v-else-if="failed">
            <span>{{ $t('general.generic_error') }}</span>
            <button class="btn button-default participants-retry" type="button" @click.stop="failedMore ? moreUsers() : loadUsers(true)">
              {{ $t('general.retry') }}
            </button>
          </template>
          <template v-else-if="usersCapped.length > 0">
            <router-link
              v-for="(user) in usersCapped"
              :key="user.id"
              :to="generateProfileLink(user)"
              class="user-list-row"
            >
              <UserAvatar
                :user-id="user.id"
                class="avatar-small"
                :compact="true"
              />
              <div class="user-list-names">
                <NameWithEmoji
                  class="username"
                  :title="'@'+user.screen_name_full_ui"
                  :name="nameOf(user)"
                  :emoji="user.emoji"
                />
                <span class="user-list-screen-name">{{ user.screen_name_ui }}</span><UnicodeDomainIndicator :user="user" />
              </div>
            </router-link>
          </template>
          <template v-else>
            {{ $t('search.no_results') }}
          </template>
        </div>
      </template>
      <template v-if="full" #footer>
        <button class="btn button-default participants-prev" :disabled="loading || page === 0" @click="page--; $refs.list.scrollTop = 0">{{ $t('status.participants_previous') }}</button>
        <span>{{ page + 1 }} / {{ Math.max(1, Math.ceil(users.length / 20)) }}</span>
        <button class="btn button-default participants-next" :disabled="loading || (page + 1) * 20 >= users.length" @click="page++; $refs.list.scrollTop = 0">{{ $t('status.participants_next') }}</button>
        <button v-if="hasMore" class="btn button-default" :disabled="loading" @click="moreUsers">{{ $t('status.load_more_participants') }}</button>
        <button class="btn button-default participants-close" @click="closeFull">{{ $t('general.close') }}</button>
      </template>
    </component>
  </Teleport>
</template>

<script src="./user_list_popover.js"></script>

<style lang="scss">
#modal .participant-dialog .dialog-modal.panel {
  .dialog-modal-footer {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;

    span {
      white-space: nowrap;
    }

    button {
      padding: 0.5em 1em;
    }
  }
}

.user-list-popover {
  padding: 0.5em;
  max-height: 40vh;
  overflow-y: auto;

  --emoji-size: calc(var(--emojiSize, 32px) / 2);

  &.-full {
    width: min(28rem, 80vw);
    height: min(55vh, 35rem);
    max-height: none;
    text-align: left;
  }

  .user-list-row {
    padding: 0.25em;
    display: flex;
    flex-direction: row;
    color: var(--text);

    .user-list-names {
      display: flex;
      flex-direction: column;
      margin-left: 0.5em;
      min-width: 5em;
    }

    .user-list-screen-name {
      font-size: 0.65em;
    }
  }
}

</style>
